import React, { useEffect } from 'react'
import PaginationSection from './PaginationSection'
import { Box, Grid, IconButton, Paper, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SquareFootIcon from '@mui/icons-material/SquareFoot';


const ActionsButton = ({onEdit, onVariants, rowItem}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <IconButton sx={{ padding: 0 }} onClick={() => onEdit(rowItem)}>
          <EditOutlinedIcon style={{ fontSize: {lg:'1.5rem'}, color: 'black'}}/>
        </IconButton>
      </Box>
    </>
  )
}

const counterStyle = {sx: { fontSize:{xs: '1rem', md: '1rem'}, px: "0.25rem", py: "0.125rem", backgroundColor: '#acacacff', borderRadius: "0.25rem" }};


function ProductGrid({
    tableData = [],
    onEdit,
    onVariants,
    page, 
    rowsPerPage,
    totalPages,
    onPageChange,
    onRowsPerPageChange,
    isLoading,
    showCharacteristicIcons,
    isVariant
}) {
  const [rows, setRows] = React.useState([]);

  useEffect( () => {
    setRows(tableData);
  },[tableData]);

  const getCharacteristicCount = (product) => {
    const items = product?.characteristics || []
    const filteredCharacteristics = items.filter(item => item?.primary !== true)

    return filteredCharacteristics.length || 0
  }

  return (
    <>
      <Box>
        <Grid container spacing={2} alignItems="stretch">
          {rows.map((item, index) => (
            <Grid
              key={index}
              item
              xs={12}
              sm={12}
              md={6}
              lg={4}
              sx={{ display: "flex" }} // allow item to stretch its child
            >
              <Paper sx={{ p: 2, width: "100%", display: "flex", flexDirection: "column", flexGrow: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={9} sm={10} md={10} lg={10} xl={10}>
                    <Typography
                      sx={{
                        color: "#2C2C2C",
                        fontSize: "1.25rem",
                        fontWeight: "600",
                      }}
                    >
                      {item.productName}
                    </Typography>
                  </Grid>
                  <Grid item xs={3} sm={2} md={2} lg={2} xl={2}>
                    <ActionsButton
                      onEdit={onEdit}
                      onVariants={onVariants}
                      rowItem={item}
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: "column",
                    maxHeight: "15rem",
                    overflowY: "auto",
                    gap: 1,
                    pt: 1
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      gap: 2
                    }}
                  >
                    <Box
                      {...counterStyle}
                    >
                      <Typography
                        sx={{
                          color: "#2C2C2C",
                          fontSize: "1rem",
                          overflowWrap: "break-word",
                        }}
                      >
                        {getCharacteristicCount(item)} caracteristicas asignadas
                      </Typography>
                    </Box>
                  </Box>
                  {item.characteristics?.map((char, i) => (
                    char?.primary !== true && (
                      <Box 
                        key={i}
                        sx={{
                          border: 1,
                          borderColor: '#FC581F30',
                          borderRadius: ".25rem",
                          p: 1,
                          display: "flex",
                          flexDirection: "row",
                          gap: 2
                        }}
                      >
                        {showCharacteristicIcons(char)}
                        
                        <Typography
                          sx={{
                            color: "#2C2C2C",
                            fontSize: "1rem",
                            overflowWrap: "break-word",
                          }}
                        >
                          {char.characteristicName}
                        </Typography>
                      </Box>
                    )
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      <PaginationSection 
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        isLoading={isLoading}
      />
    </>
  )
}

export default ProductGrid